import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { getInitials } from '@/utils/get-initials';
import { AvatarForm } from '../avatar/avatar-form';
import { EditAdminProfileUseForm } from './use-edit-admin-profile-form';

type Props = {
  form: EditAdminProfileUseForm;
};

export const selectUserInitials = ({
  firstname,
  lastname,
}: {
  firstname: string;
  lastname: string;
}) => {
  const initInitials = getInitials({ firstname, lastname });
  const [initials, setInitials] = useState<string>(initInitials);
  useEffect(() => {
    const _initials = getInitials({ firstname, lastname });
    setInitials(_initials);
  }, [firstname, lastname]);

  return {
    initials,
  };
};

const EditAdminProfileForm = ({ form }: Props) => {
  const { t } = useTranslation();

  const { picture, firstname, lastname } = form.getValues();
  const { initials } = selectUserInitials({ firstname, lastname });

  return (
    <Form {...form}>
      <form className="grid gap-4">
        <AvatarForm
          form={form}
          fieldName="file"
          currentAvatar={picture}
          placeholder={initials}
          onDeleteAvatar={() => {
            form.setValue('picture', null);
          }}
        />

        <FormField
          control={form.control}
          name="lastname"
          render={({ field }) => (
            <FormItem className="grid gap-2">
              <FormLabel>
                {t('update-doctor-substitute-form.lastname.label')}
              </FormLabel>
              <FormControl>
                <Input
                  type="text"
                  placeholder=""
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        ></FormField>
        <FormField
          control={form.control}
          name="firstname"
          render={({ field }) => (
            <FormItem className="grid gap-2">
              <FormLabel>
                {t('update-doctor-substitute-form.firstname.label')}
              </FormLabel>
              <FormControl>
                <Input
                  type="text"
                  placeholder=""
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        ></FormField>
      </form>
    </Form>
  );
};

export default EditAdminProfileForm;
